var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPrimaryAs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "62.906427205454264 487.02127268320004 506.0664382632642 41.368221501621576",
    width: 506,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.19 488.29L70.19 503.55L76 503.55L76 488.29L83.35 488.29L83.35 527.77L76 527.77L76 511.24L70.19 511.24L70.19 527.77L62.91 527.77L62.91 488.29L70.19 488.29Z",
    id: "aNGIrwwfi"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81 488.29L105.81 496.24L95.22 496.24L95.22 503.52L105.09 503.52L105.09 511.21L95.22 511.21L95.22 519.7L105.81 519.7L105.81 527.77L87.9 527.77L87.9 488.29L105.81 488.29Z",
    id: "ajw5hH5S2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.59 488.29L116.59 519.7L126.68 519.7L126.68 527.77L109.24 527.77L109.24 488.29L116.59 488.29Z",
    id: "a1J5rfpfGr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 488.29L136.1 519.7L146.19 519.7L146.19 527.77L128.75 527.77L128.75 488.29L136.1 488.29Z",
    id: "a1djt4dQq5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.89 488.29L165.89 496.24L155.3 496.24L155.3 503.52L165.17 503.52L165.17 511.21L155.3 511.21L155.3 519.7L165.89 519.7L165.89 527.77L147.97 527.77L147.97 488.29L165.89 488.29Z",
    id: "g3B2ytrbUA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.67 520.21C176.77 520.21 177.71 519.77 178.49 518.88C179.27 518 179.66 516.92 179.66 515.66C179.66 514.64 179.38 513.73 178.83 512.94C178.25 512.15 177.19 511.26 175.63 510.27C173.42 508.9 171.74 507.38 170.58 505.7C169.41 504.03 168.82 501.9 168.82 499.32C168.82 496.04 169.74 493.27 171.57 491.02C173.4 488.77 175.83 487.64 178.85 487.64C180.92 487.64 183.08 488.34 185.31 489.74C185.31 490.68 185.31 498.22 185.31 499.16C183.33 496.76 181.43 495.57 179.61 495.57C178.71 495.57 177.93 495.91 177.27 496.59C176.61 497.26 176.28 498.08 176.28 499.05C176.28 499.99 176.55 500.8 177.09 501.48C177.61 502.16 178.59 502.9 180.02 503.69C182.38 505.01 184.16 506.52 185.38 508.22C186.6 509.93 187.21 512.24 187.21 515.15C187.21 518.81 186.16 521.93 184.06 524.51C181.97 527.1 179.41 528.39 176.39 528.39C174.05 528.39 171.52 527.5 168.82 525.73C168.82 525.08 168.82 521.83 168.82 515.97C171.95 518.8 174.24 520.21 175.67 520.21Z",
    id: "d1yBOoJDsM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47 488.29L209.47 496.3L203.09 496.3L203.09 527.77L195.77 527.77L195.77 496.3L189.62 496.3L189.62 488.29L209.47 488.29Z",
    id: "a1R7ZOF1fu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.89 488.29C226.45 488.29 228.52 489.12 230.1 490.78C231.69 492.44 232.48 494.8 232.48 497.86C232.48 500.37 231.91 502.5 230.78 504.27C229.64 506.03 227.94 507.42 225.68 508.44C228.51 509.01 230.27 511.27 230.95 515.23C231.09 516.07 231.8 520.25 233.09 527.77L225.07 527.77C224.36 521.21 223.97 517.57 223.89 516.85C223.68 515 223.33 513.65 222.85 512.8C222.36 511.95 221.61 511.53 220.6 511.53C220.56 511.53 220.33 511.53 219.93 511.53L219.93 527.77L212.6 527.77L212.6 488.29C219.38 488.29 223.14 488.29 223.89 488.29ZM219.93 504.42C220.89 504.42 221.42 504.42 221.53 504.42C222.67 504.42 223.54 504 224.14 503.15C224.74 502.3 225.04 501.23 225.04 499.92C225.04 498.6 224.78 497.61 224.25 496.95C223.73 496.29 222.93 495.96 221.87 495.96C221.74 495.96 221.09 495.96 219.93 495.96L219.93 504.42Z",
    id: "akyJFbrJ6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33 488.29L257.61 527.77L249.63 527.77L248.51 519.93L242.48 519.93L241.34 527.77L233.83 527.77L242.04 488.29L249.33 488.29ZM243.52 512.86L247.5 512.86L245.54 499.08L243.52 512.86Z",
    id: "c816XxvMxg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3 488.29C269.45 495.8 270.64 499.97 270.88 500.8C271.95 504.52 272.76 507.73 273.33 510.45C273.36 510.45 273.49 510.45 273.72 510.45L273.54 503.77L273.54 488.29L280.57 488.29L280.57 527.77L273.13 527.77C270.98 520.26 269.79 516.09 269.55 515.26C268.48 511.54 267.66 508.32 267.09 505.58C267.07 505.58 266.93 505.58 266.69 505.58L266.87 512.26L266.87 527.77L259.84 527.77L259.84 488.29L267.3 488.29Z",
    id: "c8pfJvujH2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.16 488.29C296.91 488.29 299.19 489.11 301.01 490.73C302.82 492.35 304.12 494.66 304.89 497.66C305.67 500.66 306.06 503.97 306.06 507.59C306.06 513.69 304.96 518.57 302.78 522.25C300.59 525.93 297.39 527.77 293.17 527.77C292.62 527.77 289.89 527.77 284.99 527.77L284.99 488.29C290.49 488.29 293.55 488.29 294.16 488.29ZM292.31 520.04C292.62 520.04 292.79 520.04 292.83 520.04C296.63 520.04 298.53 515.72 298.53 507.08C298.53 503.74 298.12 501.05 297.3 499.02C296.48 496.98 295.14 495.96 293.28 495.96C293.21 495.96 292.89 495.96 292.31 495.96L292.31 520.04Z",
    id: "c3EwjPdXGy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.3 488.29L329.58 527.77L321.6 527.77L320.49 519.93L314.46 519.93L313.31 527.77L305.81 527.77L314.02 488.29L321.3 488.29ZM315.5 512.86L319.48 512.86L317.51 499.08L315.5 512.86Z",
    id: "c3a9qdYQnN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.13 488.29L365.41 527.77L357.43 527.77L356.32 519.93L350.29 519.93L349.14 527.77L341.64 527.77L349.85 488.29L357.13 488.29ZM351.33 512.86L355.31 512.86L353.34 499.08L351.33 512.86Z",
    id: "a31mTVLKbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.1 488.29C377.25 495.8 378.45 499.97 378.68 500.8C379.75 504.52 380.57 507.73 381.14 510.45C381.17 510.45 381.29 510.45 381.52 510.45L381.34 503.77L381.34 488.29L388.37 488.29L388.37 527.77L380.94 527.77C378.79 520.26 377.59 516.09 377.35 515.26C376.29 511.54 375.47 508.32 374.9 505.58C374.87 505.58 374.74 505.58 374.49 505.58L374.67 512.26L374.67 527.77L367.64 527.77L367.64 488.29L375.1 488.29Z",
    id: "dlSlVMzKp"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.49 488.29L411.49 496.3L405.12 496.3L405.12 527.77L397.79 527.77L397.79 496.3L391.64 496.3L391.64 488.29L411.49 488.29Z",
    id: "e1jCUVv1r5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.33 488.29L422.33 527.77L414.94 527.77L414.94 488.29L422.33 488.29Z",
    id: "g1N7xZeuT9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.93 488.29C440.48 488.29 442.55 489.12 444.14 490.78C445.72 492.44 446.51 494.8 446.51 497.86C446.51 500.37 445.95 502.5 444.81 504.27C443.68 506.03 441.98 507.42 439.71 508.44C442.55 509.01 444.31 511.27 444.98 515.23C445.12 516.07 445.84 520.25 447.12 527.77L439.1 527.77C438.4 521.21 438 517.57 437.93 516.85C437.72 515 437.37 513.65 436.88 512.8C436.39 511.95 435.64 511.53 434.64 511.53C434.59 511.53 434.37 511.53 433.96 511.53L433.96 527.77L426.64 527.77L426.64 488.29C433.41 488.29 437.17 488.29 437.93 488.29ZM433.96 504.42C434.92 504.42 435.45 504.42 435.56 504.42C436.7 504.42 437.57 504 438.18 503.15C438.78 502.3 439.08 501.23 439.08 499.92C439.08 498.6 438.81 497.61 438.29 496.95C437.76 496.29 436.97 495.96 435.9 495.96C435.77 495.96 435.12 495.96 433.96 495.96L433.96 504.42Z",
    id: "e1D5cwTtET"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.45 488.29C456.45 503.98 456.45 512.7 456.45 514.44C456.45 516.52 456.68 518.08 457.14 519.12C457.6 520.17 458.29 520.69 459.2 520.69C460.16 520.69 460.88 520.22 461.35 519.26C461.83 518.31 462.06 516.88 462.06 514.98C462.06 513.2 462.06 504.3 462.06 488.29L469.41 488.29C469.41 504.61 469.41 513.67 469.41 515.49C469.41 519.6 468.51 522.78 466.72 525.02C464.92 527.27 462.39 528.39 459.14 528.39C455.98 528.39 453.53 527.3 451.78 525.13C450.03 522.97 449.15 519.75 449.15 515.49C449.15 513.67 449.15 504.61 449.15 488.29L456.45 488.29Z",
    id: "a37jTUgdU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.64 520.21C480.74 520.21 481.68 519.77 482.46 518.88C483.24 518 483.63 516.92 483.63 515.66C483.63 514.64 483.35 513.73 482.79 512.94C482.22 512.15 481.16 511.26 479.6 510.27C477.39 508.9 475.71 507.38 474.55 505.7C473.38 504.03 472.79 501.9 472.79 499.32C472.79 496.04 473.7 493.27 475.54 491.02C477.37 488.77 479.8 487.64 482.82 487.64C484.89 487.64 487.04 488.34 489.28 489.74C489.28 490.68 489.28 498.22 489.28 499.16C487.3 496.76 485.4 495.57 483.58 495.57C482.68 495.57 481.9 495.91 481.24 496.59C480.58 497.26 480.25 498.08 480.25 499.05C480.25 499.99 480.52 500.8 481.06 501.48C481.58 502.16 482.56 502.9 483.99 503.69C486.35 505.01 488.13 506.52 489.35 508.22C490.57 509.93 491.18 512.24 491.18 515.15C491.18 518.81 490.13 521.93 488.03 524.51C485.94 527.1 483.38 528.39 480.36 528.39C478.02 528.39 475.49 527.5 472.79 525.73C472.79 525.08 472.79 521.83 472.79 515.97C475.92 518.8 478.21 520.21 479.64 520.21Z",
    id: "a6tjiBat8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.39 488.29L513.39 496.3L507.01 496.3L507.01 527.77L499.69 527.77L499.69 496.3L493.54 496.3L493.54 488.29L513.39 488.29Z",
    id: "b2jC16E29I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.44 519.59C558.53 519.59 559.47 519.15 560.25 518.26C561.03 517.37 561.42 516.3 561.42 515.03C561.42 514.01 561.15 513.11 560.59 512.32C560.02 511.52 558.95 510.64 557.39 509.65C555.19 508.28 553.51 506.76 552.35 505.08C551.17 503.4 550.58 501.28 550.58 498.69C550.58 495.42 551.5 492.65 553.33 490.4C555.17 488.15 557.59 487.02 560.61 487.02C562.68 487.02 564.84 487.72 567.08 489.12C567.08 490.06 567.08 497.6 567.08 498.54C565.1 496.14 563.2 494.94 561.38 494.94C560.48 494.94 559.7 495.28 559.03 495.96C558.37 496.64 558.04 497.46 558.04 498.42C558.04 499.37 558.31 500.18 558.85 500.86C559.38 501.54 560.36 502.27 561.78 503.07C564.14 504.39 565.93 505.9 567.15 507.59C568.36 509.31 568.97 511.62 568.97 514.53C568.97 518.19 567.92 521.31 565.83 523.89C563.73 526.48 561.18 527.77 558.16 527.77C555.81 527.77 553.29 526.88 550.59 525.11C550.59 524.46 550.59 521.2 550.59 515.35C553.72 518.18 556 519.59 557.44 519.59Z",
    id: "crd47Invh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 488.29L548.28 527.77L540.3 527.77L539.19 519.93L533.16 519.93L532.01 527.77L524.51 527.77L532.72 488.29L540 488.29ZM534.2 512.86L538.18 512.86L536.21 499.08L534.2 512.86Z",
    id: "b6sfn4KHEp"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aNGIrwwfi",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aNGIrwwfi",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajw5hH5S2",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ajw5hH5S2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1J5rfpfGr",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1J5rfpfGr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1djt4dQq5",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1djt4dQq5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g3B2ytrbUA",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g3B2ytrbUA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1yBOoJDsM",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1yBOoJDsM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1R7ZOF1fu",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1R7ZOF1fu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#akyJFbrJ6",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#akyJFbrJ6",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c816XxvMxg",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c816XxvMxg",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8pfJvujH2",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8pfJvujH2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3EwjPdXGy",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3EwjPdXGy",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3a9qdYQnN",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3a9qdYQnN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a31mTVLKbf",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a31mTVLKbf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dlSlVMzKp",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dlSlVMzKp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1jCUVv1r5",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1jCUVv1r5",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1N7xZeuT9",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g1N7xZeuT9",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1D5cwTtET",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1D5cwTtET",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a37jTUgdU",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a37jTUgdU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6tjiBat8",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6tjiBat8",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2jC16E29I",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2jC16E29I",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crd47Invh",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crd47Invh",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6sfn4KHEp",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6sfn4KHEp",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimaryAs);
export default __webpack_public_path__ + "static/media/LogoPrimaryAS.e4cdbc214fddc1f5175afff556d661a5.svg";
export { ForwardRef as ReactComponent };